import React, { useEffect, useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import {
  MdOutlineLocationOn,
  MdOutlineFax,
  MdMailOutline,
} from "react-icons/md";
import { IoArrowUpCircleOutline } from "react-icons/io5";
import logo from "../Images/logo-4.png";
import { BASEAPIURL, token } from "../env";

const ContactForm = () => {
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const payload = {
      tokenData: token,
      Contact: {
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        subject: formData.subject,
        message: formData.message,
      },
    };

    try {
      const res = await fetch(
        `${BASEAPIURL}/InsertContactus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await res.text();
      console.log("Response:", result);

      if (res.ok) {
        alert("Message sent successfully!");
        setFormData({ name: "", phoneNumber: "", email: "", message: "" });
      } else {
        alert("Something went wrong: " + result);
      }
    } catch (err) {
      console.error("API error:", err);
      alert("An error occurred while sending your message.");
    }

    setValidated(true);
  };

  return (
    <form
      className="md:pr-8 border-2-black max-w-3xl mx-auto"
      noValidate
      validated={validated.toString()}
      onSubmit={handleSubmit}
      style={{ width: "100%" }}
    >
      <div className="mb-4">
        <br />
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          className="min-h-[48px] leading-[48px] bg-[#3A384D] border border-transparent rounded-xl focus:outline-none focus:border focus:border-[#86b7fe] w-full px-5"
          placeholder="Enter Name"
        />
      </div>
      <div className="mb-4">
        <input
          type="tel"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleChange}
          required
          className="min-h-[48px] leading-[48px] bg-[#3A384D]  border border-transparent rounded-xl focus:outline-none focus:border focus:border-[#86b7fe] w-full px-5"
          placeholder="Enter Phone Number"
        />
      </div>
      <div className="mb-4">
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="min-h-[48px] leading-[48px] bg-[#3A384D]  border border-transparent rounded-xl focus:outline-none focus:border focus:border-[#86b7fe] w-full px-5"
          placeholder="Enter Email"
        />
      </div>
      <div className="mb-4">
        <input
          type="text"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          className="min-h-[48px] leading-[48px] bg-[#3A384D]  border border-transparent rounded-xl focus:outline-none focus:border focus:border-[#86b7fe] w-full px-5"
          placeholder="Enter Subject"
        />
      </div>
      <div className="mb-4">
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          className="min-h-[48px] bg-[#3A384D]  border border-transparent rounded-xl focus:outline-none focus:border focus:border-[#86b7fe] w-full px-5"
          placeholder="Enter Message"
          rows="4"
        />
      </div>
      <div className="text-end">
        <button
          type="submit"
          className="bg-blue-950 hover:bg-opacity-90 px-10 py-3 rounded-md mb-4"
          style={{ backgroundColor: "black", color: "white" }}
        >
          Send
        </button>
      </div>
    </form>
  );
};

export default function Contact() {
  useEffect(() => {
    scrollToTop();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      <div className="container">
        <div className="row ">
          <div
            className="text-center"
            style={{
              cursor: "pointer",
              fontSize: "3em",
              fontWeight: 600,
              color: "#DC143C",
            }}
          >
            Contact Us
          </div>
        </div>

        <section className="ezy__contact1 dark py-10 md:py-14 bg-white dark:bg-[#0b1727] text-white overflow-hidden">
        <div className="w-full h-full mb-12 rounded-xl overflow-hidden shadow-lg">
        <iframe
          title="Jai Club Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.6432846389807!2d75.81016917514495!3d26.91481386000072!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db6a945f27e7d%3A0x573bf52c0d5579df!2sJai%20Club!5e0!3m2!1sen!2sin!4v1718616200055!5m2!1sen!2sin"
          width="100%"
          height="100%"
          allowFullScreen
          loading="lazy"
          style={{ border: 0 }}
        ></iframe>
      </div>
        </section>

        <div className="row align-items-center mb-5">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="card p-2 border-0">
              <div className="d-flex align-items-center mb-2">
                <img
                  className=""
                  loading="lazy"
                  src={logo}
                  alt=""
                  style={{ width: 100 }}
                />
                <div className="">
                  <div
                    className="nav-links-footer text-start"
                    style={{
                      cursor: "pointer",
                      fontSize: "3em",
                      fontWeight: 600,
                      color: "#DC143C",
                      fontFamily: '"Playwrite FR Moderne", cursive',
                    }}
                  >
                    Jai Club
                  </div>
                  <div
                    className="nav-links-footer text-start"
                    style={{
                      cursor: "pointer",
                      fontSize: "1em",
                      fontWeight: 600,
                      color: "#000",
                    }}
                  >
                    THE TRUE SPIRIT OF LIFE
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center mb-1">
                <div className="justify-content-center align-items-center d-flex rounded-1">
                  <MdOutlineLocationOn
                    style={{ fontSize: 18, color: "#DC143C" }}
                  />{" "}
                </div>
                <div
                  className="text-start ps-3"
                  style={{
                    cursor: "pointer",
                    fontSize: "1em",
                    fontWeight: 400,
                    color: "#000",
                  }}
                >
                  Mahaveer Marg, C-Scheme, Jaipur - 302001 (Raj.)
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="justify-content-center align-items-center d-flex rounded-1">
                  <FaPhoneAlt style={{ fontSize: 10, color: "#DC143C" }} />{" "}
                </div>
                <div
                  className="text-start ps-4"
                  style={{
                    cursor: "pointer",
                    fontSize: "1em",
                    fontWeight: 400,
                    color: "#000",
                  }}
                >
                  0141-2372321,2372322
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="justify-content-center align-items-center d-flex rounded-1">
                  <MdOutlineFax style={{ fontSize: 16, color: "#DC143C" }} />{" "} Jaiclub Help Line :
                </div>
                <div>
                  <a
                    className="text-start ps-3"
                    style={{
                      cursor: "pointer",
                      fontSize: "1em",
                      fontWeight: 400,
                      color: "#000",
                      textDecoration: "none",
                    }}
                    href="tel:98291233"
                  >
                    9829123333
                  </a>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="justify-content-center align-items-center d-flex rounded-1">
                  <MdMailOutline style={{ fontSize: 16, color: "#DC143C" }} />{" "}
                </div>
                <div>
                  <a
                    className="text-start ps-3"
                    style={{
                      cursor: "pointer",
                      fontSize: "1em",
                      fontWeight: 400,
                      color: "#000",
                      textDecoration: "none",
                    }}
                    href="mailto:jaiclub@hotmail.com"
                  >
                    jaiclub@hotmail.com
                  </a>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="justify-content-center align-items-center d-flex rounded-1">
                  <MdMailOutline style={{ fontSize: 16, color: "#DC143C" }} />{" "}
                </div>
                <div>
                  <a
                    className="text-start ps-3"
                    style={{
                      cursor: "pointer",
                      fontSize: "1em",
                      fontWeight: 400,
                      color: "#000",
                      textDecoration: "none",
                    }}
                    href="Info@jaiclub.in"
                  >
                    Info@jaiclub.in
                  </a>
                </div>
              </div>
            </div>
            <div className="card p-2 border-0">
              <div className="">
                <div
                  className="nav-links-footer text-start"
                  style={{
                    cursor: "pointer",
                    fontSize: "1em",
                    fontWeight: 600,
                    color: "#DC143C",
                    fontFamily: '"Playwrite FR Moderne", cursive',
                  }}
                >
                  JaiClub Prime Guest House
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="justify-content-center align-items-center d-flex rounded-1">
                  <FaPhoneAlt style={{ fontSize: 10, color: "#DC143C" }} />{" "}
                </div>
                <div
                  className="text-start ps-4"
                  style={{
                    cursor: "pointer",
                    fontSize: "1em",
                    fontWeight: 400,
                    color: "#000",
                  }}
                >
                  0141-2364472,2364471
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="justify-content-center align-items-center d-flex rounded-1">
                  <MdMailOutline style={{ fontSize: 16, color: "#DC143C" }} />{""}
                </div>
                <div>
                  <a
                    className="text-start ps-3"
                    style={{
                      cursor: "pointer",
                      fontSize: "1em",
                      fontWeight: 400,
                      color: "#000",
                      textDecoration: "none",
                    }}
                    href="mailto:Booking@jaiclub.in"
                  >
                    Booking@jaiclub.in
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="card border-0">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>

      {/* Add the Contact Form directly here */}

      <div
        className="scroll-to-top-button rounded-2"
        onClick={scrollToTop}
        style={{
          width: 40,
          height: 40,
          backgroundColor: "#ff68f0",
          color: "#fff",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <IoArrowUpCircleOutline style={{ fontSize: 30 }} />
      </div>
    </div>
  );
}
